import { accessRole } from "../../../../helpers/access_role"
import React, { useState, Fragment, Component } from 'react'
import Shimmer from "react-shimmer-effect";
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    TabContent, TabPane, Nav, NavItem, NavLink,
    Button,
    Alert,
    UncontrolledAlert,
    Modal, ModalHeader, ModalBody, ModalFooter
} from "reactstrap"
import CustomSelect from "../../../../helpers/ui/CustomSelect";
import { AvForm } from "availity-reactstrap-validation"
import {ConfirmAlert} from "../../../../helpers/ui/alert";
import apiResponse from '../../../../../src/services/apiResponse';
import IndexBloc from '../index/Blocs/IndexBloc'
import { year } from "javascript-time-ago/gradation";
import moment from "moment"
import './style.css';
import DatePickerCustom from '../../../../helpers/ui/DatePickerCustom'

var reformatOptions = function(raw) {
  return raw.map(function(data) {
    var newObj = {};
    newObj["label"] = data;
    newObj["value"] = data;

    return newObj;
  });
};
var reformatOptionWorkunits = function (raw, label, value) {
  return raw.map(function (data) {
      var newObj = {};
      newObj["label"] = data[label];
      newObj["value"] = data[value];

      return newObj;
  });
};
class IndexView extends Component {

  indexBloc = new IndexBloc()

    constructor(props) {
      super(props)
      this.state = {
        selectYearOption:[],
        loading:false,
        display:null,
        workUnitList:[],
        workUnit:null,
        startDate:moment().format('YYYY'),
        linkExport:null,
        linkBackend: process.env.REACT_APP_SERVICE_CORE_URL == 'http://localhost:8001/' ? process.env.REACT_APP_SERVICE_CORE_URL : process.env.REACT_APP_SERVICE_CORE_URL + '/'
      }
    }
   
    setYear = (value) => {
      console.log('year',value)
      this.setState({
        startDate:moment(value.toString()).format('YYYY'),
        display:null
      })
      this.timeoutId = setTimeout(() => {
        this.loadData()
      }, 3000);
    }
    setWorkUnit = (value) =>{
      console.log('year',value.value)
      this.setState({
        workUnit:value.value,
        display:null
      })
      this.timeoutId = setTimeout(() => {
        this.loadData()
      }, 3000);
    }
    loadData = () => {
      //<Redirect to={"http://aldi.com"} />
      let query = {
          start_date: this.state.startDate,
          end_date: null,
          work_unit: this.state.workUnit,
          status_pegawai: null,
          tipe:'laporan'
      }
      this.indexBloc.fetchPensiunList(query);
  }
  loadDataWorkUnit = () => {
    //<Redirect to={"http://aldi.com"} />
    let query = {

    }
    this.indexBloc.fetchWorkUnit(query);
}
  componentDidMount() {
    this.indexBloc.pensiunListChannel.subscribe((result) => {
      switch (result.status) {
          case apiResponse.COMPLETED:
              let response = result.data.response
              this.setState({
                loading:false,
                display:true,
                linkExport:response.export.file_url
              })
              console.log(response)
              break;
          default:
              break
      }
    })
    this.indexBloc.workUnitChannel.subscribe((result) => {
      switch (result.status) {
          case apiResponse.COMPLETED:
              let response = result.data.response
              console.log(response)
              let options = reformatOptionWorkunits(response.result, 'work_unit_name_tabs', 'hirarki');
              this.setState({
                workUnitList:options
              })
              
              break;
          default:
              break
      }
    })
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let i = currentYear - 5; i <= currentYear + 5; i++) {
      years.push(i);
    }
    
    this.setState({
      selectYearOption: reformatOptions(years)
    })
      this.loadData()
      this.loadDataWorkUnit()
  }
  renderYearContent = (year) => {
    const tooltipText = `Tooltip for year: ${year}`;
    return <span title={tooltipText}>{year}</span>;
  };
  
  componentWillUnmount() {
    clearTimeout(this.timeoutId);
    this.indexBloc.pensiunListChannel?.unsubscribe()
    this.indexBloc.workUnitChannel?.unsubscribe()
  }
  confirmResponse = (response) => {
    let forState = {}
    switch (response) {
        case apiResponse.LOADING:
            forState = {
                loading: true,
            }
            this.submitData()
            break;
        case apiResponse.COMPLETED:
            forState = {
                success: true,
            }
            break;
        case apiResponse.ERROR:
            forState = {
                failed: true
            }
            break;
        default:
    }
    this.setState(forState)
}
    render() {
      return (
        <Fragment>
          <Card style={{maxHeight: '300px', minHeight: '300px'}}>
            <CardBody className="">
              <CardTitle className="h4 mb-4">
              LAPORAN PENSIUN
              <hr />
              </CardTitle>
              <div className=""  style={{padding:'20px',marginLeft:'50px'}}>
                <AvForm
                    className="needs-validation"
                    onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                >
                <Row>
                  <Col sm={4}>
                    <CustomSelect 
                          name="work_unit"
                          errorMessage="Pilih Unit"
                          placeholder="Pilih Unit"
                          // onChange={val => this.setState({ startDate:moment(val.value).format('YYYY') })}
                          onChange={val => this.setWorkUnit(val)}
                          options={this.state.workUnitList}
                          // defaultValue={this.state.startDate}
                          // isAvForm={false}
                      />
                  </Col>
                  <Col sm={2}>
                    {/* <CustomSelect 
                        name="start_date"
                        errorMessage="Pilih Tahun"
                        placeholder="Pilih Tahun"
                        // onChange={val => this.setState({ startDate:moment(val.value).format('YYYY') })}
                        onChange={val => this.setYear(val)}
                        options={this.state.selectYearOption}
                        defaultValue={this.state.startDate}
                        // isAvForm={false}
                    /> */}
                     <DatePickerCustom
                     style={{width: '120%'}}
                      name="employee_date_of_birth"
                      id="employee_date_of_birth"
                      placeholder="Tahun Pensiun"
                      onChange={val => this.setYear(val)}
                      errorMessage="Masukkan Tahun Pensisun"
                      isWeekday={false}
                      dateFormat="yyyy"
                    />
                  </Col>
                  <Col sm={4}>
                  {
                    this.state.display ?
                    <button type="button" className="btn btn-success"><a href={this.state.linkBackend + this.state.linkExport} target='_blank' style={{ color: 'white' }}><i className="fa fa-download"></i> EXPORT EXCEL</a></button>
                    : 
                    <div className="loader"></div>
                  }
                  </Col>
                </Row>
                </AvForm>
                <br /> 
                
              </div>
            </CardBody>
          </Card>
          <ConfirmAlert
              confirmTitle="Konfirmasi!"
              confirmInfo="Apakah anda yakin akan menyimpan data ini?"

              loadingTitle="Mengirim data..."
              loadingInfo="Tunggu beberapa saat"

              successTitle="Berhasil!"
              successInfo="Data berhasil disimpan"

              failedTitle="Gagal!"
              failedInfo="Data gagal disimpan"

              showConfirm={this.state.confirm}
              showLoading={this.state.loading}
              showSuccess={this.state.success}
              showFailed={this.state.failed}

              response={this.confirmResponse}
                />
        </Fragment>
      )
    }
  }
  export default IndexView